import { FormFieldTypes } from "../../../data/formFieldType";

export const RequirementApprovalData = {
    name: "AdditionalInfo",
    initialState: {
        searchByRequirementName: "",
        channel: null,
        statusId: null,
        requirementSection: null
    },
    formFields: [
        {
            id: "searchByRequirementName",
            lable: "Search by Requirement Name",
            Field_Name: "Search by Requirement Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "searchByRequirementName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-12 mb-3",
            },
        },
        {
            id: "channel",
            lable: "Channel",
            Field_Name: "Channel",
            fieldType: FormFieldTypes.SELECT,
            dataField: "channel",
            fieldSetting: {
                placeholder: "Select",
                options: [],
            },
            style: {
                containerCss: "col-lg-4",
            },
        },
        {
            id: "requirementSection",
            lable: "Requirement Section",
            Field_Name: "Requirement Section",
            fieldType: FormFieldTypes.SELECT,
            dataField: "requirementSection",
            fieldSetting: {
                placeholder: "Select",
                options: [],
            },
            style: {
                containerCss: "col-lg-4",
            },
        },
        {
            id: "statusId",
            lable: "Status",
            Field_Name: "Status",
            fieldType: FormFieldTypes.SELECT,
            dataField: "statusId",
            fieldSetting: {
                placeholder: "Select",
                options: [],
            },
            style: {
                containerCss: "col-lg-4",
            },
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
